var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.bodyClass},[_c('client-only',[_c('warex-gdpr')],1),_vm._v(" "),_c('warex-header',{ref:"header"}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('warex-footer'),_vm._v(" "),_c('registration-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }